import React, { createContext, ReactNode, useMemo } from 'react';
import { fallbackLanguage, MappedGlobalLanguage } from '../../configs/env';
import { withErrorBoundary } from '../../error-handling/withErrorBoundary';
import { getLanguageFromPathname } from '../../utils/getLanguageFromPathname';

export type UrlLanguageContextApi = MappedGlobalLanguage;

export const UrlLanguageContext = createContext<UrlLanguageContextApi>(fallbackLanguage);

export function RawUrlLanguageProvider(props: {children: ReactNode}) {
  const urlLanguage = useMemo(() => getLanguageFromPathname(window.location.pathname) || fallbackLanguage, []);

  return <UrlLanguageContext.Provider value={urlLanguage}>
    {props.children}
  </UrlLanguageContext.Provider>
}

export const UrlLanguageProvider = withErrorBoundary(RawUrlLanguageProvider, 'UrlLanguageProvider');
